module.exports = __webpack_public_path__ + "static/img/noData.f8bd56d9.png";